import { Component, OnDestroy, OnInit } from '@angular/core';
import { ArhivskaTableResponse, ArhivskaKnjigaClient, ArhivskaDokumentaFormDto, GetZipedDocumentsQuery } from '@kodit/core/data-api';
import { FormHelper } from '@kodit/core/form-definitions';
import { DynamicDialogRef } from '@kodit/core/shared-ui';
import { ArhivskaDokumentaForm, ArhivskaKnjigaService } from 'libs/core/moduli/podesavanje/src/lib/arhivska-knjiga/arhivska-knjiga-service';
import { LoaderService } from 'libs/core/shared-ui/src/lib/loader/loader.service';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SharedService } from '@kodit/core/services';

@Component({
  selector: 'kodit-arhivska-dokumenti-dialog',
  templateUrl: './arhivska-dokumenti-dialog.component.html',
  styleUrls: ['./arhivska-dokumenti-dialog.component.scss'],
})
export class ArhivskaDokumentiDialogComponent implements OnInit, OnDestroy {
  /** Subs */
  private _subs: Subscription = new Subscription();

  /** Forms */
  form: ArhivskaDokumentaForm;

  constructor(
    private _service: ArhivskaKnjigaService,
    private _client: ArhivskaKnjigaClient,
    private _dialogRef: DynamicDialogRef,
    private _loader: LoaderService,
    private _formHelper: FormHelper,
    private _sharedService: SharedService,
  ) {}

  ngOnInit(): void {
    this._subs.add(
      this._client.getArhivskaDokumentaForm().subscribe((res) => {
        if (res.succeeded) {
          this.form = this._service.getArhivskaDokumentaForm(res.data!);
        }
      })
    );

    this._subs.add(
      this._dialogRef.onSubmit.subscribe(() => {
        this._save();
      })
    );
  }

  private _save() {
    if (!this.form.valid) {
      this._formHelper.invalidateForm(this.form);
      return;
    }
    this._loader.setLoadingText = 'Preuzimanje je u toku...';
    this._loader.setShowLoader = true;
    this._subs.add(
      this._client
        .getArhivskaZipedFiles(
          new GetZipedDocumentsQuery({
            dto: new ArhivskaDokumentaFormDto(this.form.value)
          })
        )
        .pipe(
          finalize(() => {
            this._loader.reset();
          })
        )
        .subscribe((res) => {
          this._sharedService.downloadBlob(res.data, res.fileName, res.data.type);
          this._dialogRef.close(true);
        })
    );
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }
}
